import { SpringValues, useSpring } from '@react-spring/web';
import { ReactElement, useState, FunctionComponent } from 'react';
import React from 'react';
import { useSpringReset } from '../../hooks/useSpringReset';
import { prepareProps } from '../../utils/propUtils';
export type FadeProps = {
  show: boolean;
  children: (style: SpringValues<{
    opacity: number;
  }>) => ReactElement;
  /** skips the show animation and immediately jump to the end state */
  showImmediately?: boolean;
};
export const Fade: FunctionComponent<FadeProps> = React.memo(props => {
  const {
    show,
    showImmediately,
    children
  } = prepareProps({
    props
  });
  const [renderChildren, setRenderChildren] = useState(show);
  const reset = useSpringReset();
  const styles = useSpring({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    reset,
    immediate: showImmediately && show,
    reverse: !show,
    onStart: () => {
      if (show) {
        setRenderChildren(true);
      }
    },
    onRest: () => {
      if (!show) {
        setRenderChildren(false);
      }
    }
  });
  return renderChildren ? children(styles) : null;
});